export default "__VITE_ASSET__BeNC9g52__"